export default __webpack_public_path__ + "static/media/image-zx9.598799e2.jpg";